import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DataService_MultiStationViewVisitors } from "../../multi-station-view-visitors/shared/data.service";

@Component({
	selector: "app-multi-station-view-log-visitor",
	templateUrl: "./multi-station-view-log-visitor.component.html",
	styleUrls: ["./multi-station-view-log-visitor.component.css"],
})
export class MultiStationViewLogVisitorComponent implements OnInit {
	constructor(private visitorService: DataService_MultiStationViewVisitors, private activatedRoute: ActivatedRoute, private router: Router) {}

	ngOnInit(): void {
		this.UpdateVisitor();
	}

	//////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////

	VisitorPassDetailID: number = -1;

	SelectedTab: number = 0;
	SelectedVisitor: any;

	//
	// Display Data
	//
	FacilityName: string = "";
	FacilityLocationName: string = "";
	VisitorPassDetailStatusDesc: string = "";
	IsOnSite: boolean = false;
	Notes: string = "";
	LogDT: string = "";
	VisitorPhoto: string = "";

	//////////////////////////////////////////////

	//////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////

	UpdateVisitor() {
		//
		// Check Visitor Pass Detail ID
		//

		// Doesn't Exist, Return to main page
		if (this.activatedRoute.snapshot.params.VisitorPassDetailID != undefined) {
			this.VisitorPassDetailID = this.activatedRoute.snapshot.params.VisitorPassDetailID;
		} else {
			this.onBack();
		}

		// Invalid ID
		if (this.VisitorPassDetailID <= 0) {
			this.onBack();
		}

		//
		// Try to load data for the ID
		//
		var result = this.visitorService.VisitorLogDetailsSelect(this.VisitorPassDetailID);
		result.subscribe(
			(response: any) => {
				if (response.Success == false) {
					this.onBack();
					return;
				}

				//
				// Update Display Info
				//
				this.FacilityName = response.FacilityName;
				this.FacilityLocationName = response.FacilityLocationName;
				this.VisitorPassDetailStatusDesc = response.VisitorPassDetailStatusDesc;
				this.IsOnSite = response.IsOnSite;
				this.Notes = response.Notes;
				this.LogDT = response.LogDT;
				this.VisitorPhoto = response.VisitorPhoto;

				//
				// Update Visitor
				//
				this.SelectedVisitor = {
					PersonID: response.PersonID,
				};
			},
			(error) => {
				this.onBack();
			}
		);
	}

	//////////////////////////////////////////////

	onBack() {
		this.router.navigate(["/multistation/viewlog/"]);
	}
}
